export enum Views {
    Graphic,
    ToDo,
    Detail,
    Note,
    Add,
    Share,
    Cloud
   
}